import { getApiBaseUrl } from "../utils/getApiBaseUrl";
import { getAuthToken } from "./authApi";

const API_BASE_URL = getApiBaseUrl();

/**
 * Public newsletter subscribe (TreydoraEdBackend). Optional Bearer if user is logged in.
 */
export async function postNewsletterSubscribe(body) {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE_URL}/api/newsletter/subscribe`, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  });

  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }

  if (!res.ok) {
    const msg =
      typeof payload.message === "string" && payload.message.trim()
        ? payload.message.trim()
        : "Subscription failed. Please try again.";
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }

  return payload;
}
